import AppContext from "PFApp/app_context";
import { countFilters } from "PFApp/use_filtered_collection/format_filters";
import Select from "PFComponents/select/select";
import Tracking from "PFCore/helpers/tracking";
import { useCanCreateActivities } from "PFCore/helpers/use_can_create_activities";
import { MetaFilters } from "PFTypes/collection_filters";
import React, { useCallback, useContext, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./suggestions.scss";

type SuggestionsProps = {
  filters: MetaFilters;
};

export const Suggestions = ({ filters }: SuggestionsProps): JSX.Element => {
  const {
    store: { currentAccount, currentProfile }
  } = useContext(AppContext);
  const { t } = useTranslation("profiles");

  const history = useHistory();
  const [canCreateActivities] = useCanCreateActivities();

  const templates = currentProfile.templates.filter(
    ({ create_permitted, hidden, need_matches }) => !hidden && create_permitted && need_matches
  );
  const isFilteredALot = countFilters(filters) > 1;

  const options = useMemo(
    () =>
      templates.map((template) => ({
        id: template.id,
        displayElement: template.name,
        item: template
      })),
    [templates]
  );

  const handleActivitySuggestionChange = useCallback(
    (template) => {
      history.push(`/activities/${template.key}/new`);
      new Tracking(currentAccount, currentProfile.id).recordEvent(
        "profiles-list-activity-creation-suggestion-pick",
        {
          template_id: template.id // eslint-disable-line camelcase
        }
      );
    },
    [currentAccount, currentProfile.id, history]
  );

  return (
    <>
      {canCreateActivities && isFilteredALot && (
        <div className={css.root} data-qa-id="get-help-your-colleagues-create-task-cta">
          <Trans
            i18nKey="list.tryCreatingANewTemplate"
            t={t}
            components={[
              <span key="1" />,
              <Select
                /* @ts-ignore */
                placeholder="activity"
                readOnly
                style={{ display: "inline-block" }}
                options={options}
                handleChange={handleActivitySuggestionChange}
                key="2"
              />
            ]}
          />
        </div>
      )}
    </>
  );
};
